import { ReebeloStoreT } from '@lambda/reebelo';
import { Customer } from '../customer/types';

export enum LineItemType {
  PRODUCT = 'product',
  SHIPPING = 'shipping',
  WARRANTY = 'warranty',
}

enum CartLineItemReferenceType {
  CART_LINE = 'cart_line',
  ORDER_LINE = 'order_line',
}

enum CartStatus {
  OPEN = 'open',
  CLOSED = 'closed',
  ABANDONED = 'abandoned',
}

type AmountT = {
  currency: string;
  subTotal: number;
  taxTotal: number;
  dutiesTotal: number;
  discountTotal: number;
  shippingTotal: number;
  grandTotal: number;
};

export type NoteT = {
  name: string;
  value: string;
};

export type CartDataT = {
  store: ReebeloStoreT;
  customerId?: string;
  lines?: CartLineItemT[];
  notes?: NoteT[];
};

export type CreateLineItemDataT = {
  type: LineItemType;
  typeId: string; // reebeloPk
  quantity?: number;
  notes?: NoteT[];
};

export type UpdateLineItemDataT = { quantity: number; notes?: NoteT[] };

export interface CartLineItemVariantT {
  name: string;
  value: string;
}
export interface CartLineItemT {
  id: string;
  type: LineItemType;
  typeId: string;
  title: string;
  handle?: string | null;
  image?: string | null;
  vendor: string;
  categoryPk?: string | null;
  categoryName?: string | null;
  sku: string;
  psku: string;
  quantity: number;
  stock?: number | null;
  price: number;
  compareAtPrice: number;
  variants: CartLineItemVariantT[];
  notes: NoteT[];
  subTotal: number;
  referenceType: CartLineItemReferenceType;
  referenceId: string;
}

export type CartT = {
  id: string;
  store: ReebeloStoreT;
  createdAt: string;
  updatedAt: string;
  status: CartStatus;
  amount: AmountT;
  customer?: Customer;
  notes?: NoteT[];
  lines: CartLineItemT[];
  checkoutUrl: string;
};
